const rules = {
  'ese.required.field': '必填欄位',
  'ese.required.item': '必填項目'
}

const placeholders = {
  'ese.placeholder.please.enter.query.title': 'Please enter query title',
}

const labels = {
  'ese.realname': '真實姓名',
  'ese.account': '賬號',
  'ese.username': '用戶名',
  'ese.work.no': '工號',
  'ese.email': 'Email',
  'ese.verification.code': '驗證碼',
  'ese.password': '密碼',
  'ese.new.password': '新密碼',
  'ese.old.password': '舊密碼',
  'ese.confirm.password': '確認密碼',
  'ese.confirm.new.password': '確認新密碼',
  'ese.get.verification.code': '獲取驗證碼',
  'ese.join.factory.date': '入廠日期',
  'ese.type': '類型',
  'ese.factory': '廠區',
  'ese.institutions': '單位',
  'ese.applicant': '申請人',
  'ese.business.group': '事業群',
  'ese.business.office': '事業處',
  'ese.department': '部門',
  'ese.phone.number': '手機號碼',
  'ese.extension.number': '分機',
  'ese.position': '職位',
  'ese.title': '標題',
  'ese.content': '內容',
}

const znJSON = {
  'ese.login': '登入',
  'ese.logout': '登出',
  'ese.home': '首頁',
  'ese.view.profile': '檢視個人資料',
  'ese.system.application.center': '應用中心',
  'ese.faqs': '常見問題',
  'ese.feedback': '問題反饋',
  'ese.sign.in.to.honhai.worker.service': '鴻海員工聚合服務平台',
  'ese.don’t.have.a.xiangxin?': '沒有相信?',
  'ese.activate.with.employee.ID': '員工工號激活',
  'ese.don’t.have.an.account?': '還沒賬戶？',
  'ese.already.have.an.account?': '已有賬戶？',
  'ese.register.here': '前往註冊',
  'ese.login.here': '前往登錄',
  'ese.login.with.account': '前往賬戶登錄',
  'ese.remember.me': '記住賬號',
  'ese.want.to.try.to.login.again?': '想尝试再次登录?',
  'ese.recover.password.to.honhai.worker.service': '重置鸿海員工服务網密码',
  'ese.forgot.password?': '忘記密碼？',

  'ese.activation': '激活',
  'ese.cancel': '取消',
  'ese.delete': '刪除',
  'ese.subscribed': '已訂閲',
  'ese.subscription': '訂閲',
  'ese.finish': '結束',
  'ese.confirm': '確認',
  'ese.submit': '提交',
  'ese.close': '關閉',
  'ese.save': '保存',
  'ese.save.changes': '存儲變更',
  'ese.confirm.send': '確認送出',
  'ese.confirm.save': '確認存儲',
  'ese.send': '發送',
  'ese.send.out': '送出',
  'ese.download': '下載',
  'ese.export': '導出',
  'ese.add.to.favorites': '添加收藏',
  'ese.fill.in.example': '填寫範例',
  'ese.clear': '清除',

  'ese.not.found': '暫無數據',
  'ese.no.results.found.for': '没有找到结果關於',
  'ese.try.checking.for.typos.or.using.complete.words.': '尝试检查拼写错误或使用完整的单词.',

  'ese.hello': '您好',
  'ese.last.login.time': '上次登錄時間',
  'ese.recently.checked.in': '最近打卡',
  'ese.credits.earned': '已修學分',
  'ese.recent.consumption': '最近消費',

  'ese.notification.center': '消息中心',

  'ese.all-in-one.card.area': '一卡通專區',
  'ese.cartoon.card1': '識別證遺失',
  'ese.cartoon.card2': '臨時識別證申請',
  'ese.cartoon.card3': '派駐幹部',
  'ese.cartoon.card4': '考勤記錄',

  'ese.cartoon.card1.item1': '下載識別證/一卡通感應卡/識別證帶遺失(損耗)切結書',
  'ese.cartoon.card1.item2': '將切結書送呈單位主管、單位人資主管簽核',
  'ese.cartoon.card1.item3': '繳件方式：E-mail或紙本送交至台北人資一卡通窗口',
  'ese.cartoon.card1.item4': '識別證製作完畢後通知申請人至人資服務總處領取並簽收',

  'ese.cartoon.card2.item1': '持卡身分須為關係企業、外籍幹部、顧問、長期支援廠商、供應商',
  'ese.cartoon.card2.item2': '下載一卡通臨時識別證申請單',
  'ese.cartoon.card2.item3': '將申請單送呈單位主管、單位人資主管簽核後，透過 E-mail或紙本送交至台北人資審核',
  'ese.cartoon.card2.item4': '識別證製作完畢後通知申請人至人資服務總處領取並簽收',

  'ese.cartoon.card3.subtitle1': '識別證遺失',
  'ese.cartoon.card3.subtitle2': '識別證門禁開通',
  'ese.cartoon.card3.subtitle3': '鴻海一卡通窗口',
  'ese.cartoon.card3.item1': '請單位助理協助於派駐地申請臨時卡(無印製照片)，此卡僅可於返台前暫代使用。返台後需申請識別證遺失，製作新的識別證(申請步驟請查看識別證遺失專區)',
  'ese.cartoon.card3.item2': '派駐台幹欲開通二線門禁(大門以外的門禁)請先洽單位人資/單位助理人員',
  'ese.cartoon.card3.item3': '中央人資提供一卡通工號&流水號以助開通門禁權限',
  'ese.cartoon.card3.item4': '徐庭芳 511-3988 (addie.tf.hsu@foxconn.com) 辦公地點：虎躍廠1F大廳櫃台',

  'ese.cartoon.card4.item1': '為方便同仁即時掌握自己的出勤狀況，或依規定申請加班費/慰勞假，台北人資于集團相信APP建立【台灣地區考勤記錄】生活頻道，功能包括：出勤溫馨提醒、本週到廠記錄查詢、及重要出勤/請假/加班管理規定提醒摘錄，詳細內容請關注附檔集團相信APP',
  'ese.cartoon.card4.item2': '【台灣地區考勤記錄】說明',

  'ese.cartoon.window.label': '鴻海/鴻準一卡通窗口',
  'ese.cartoon.window.value': '徐庭芳 511-3988（addie.tf.hsu@foxconn.com) 辦公地點：台北人資服務總處辦公室（虎耀廠二樓）',

  //

  'ese.labor.and.health.insurance.area': '勞健保專區',
  'ese.labor.health.title1': '勞保給付申請',
  'ese.labor.health.title2': '健保相關申請',
  'ese.labor.health.title3': '新制勞退申請',

  'ese.labor.health.t1.subtitle1': '生育給付',
  'ese.labor.health.t1.subtitle2': '傷病給付',
  'ese.labor.health.t1.subtitle3': '老年給付',
  'ese.labor.health.t1.subtitle4': '失能給付',
  'ese.labor.health.t1.subtitle5': '家屬死亡給付',

  'ese.labor.health.t2.subtitle1': '眷屬加保',
  'ese.labor.health.t2.subtitle2': '眷屬退保',
  'ese.labor.health.t2.subtitle3': '停復保申請',
  'ese.labor.health.t2.subtitle4': '健保境外醫療核退',

  'ese.labor.health.t3.subtitle1': '勞退自提變更',
  'ese.labor.health.t3.subtitle2': '勞退金申請書',

  'ese.labor.health.t1.s1.description1': '生育給付申請書',
  'ese.labor.health.t1.s1.description2': '生育給付申請書範本',

  'ese.labor.health.t1.s2.description1': '傷病給付申請書',
  'ese.labor.health.t1.s2.description2': '傷病給付申請書範本',

  'ese.labor.health.t1.s3.description1': '老年給付申請書',
  'ese.labor.health.t1.s3.description2': '老年給付申請書範本',

  'ese.labor.health.t1.s4.description1': '失能給付申請書',
  'ese.labor.health.t1.s4.description2': '失能給付申請書範本',

  'ese.labor.health.t1.s5.description1': '家屬死亡給付申請書',
  'ese.labor.health.t1.s5.description2': '家屬死亡給付申請書範本',

  'ese.labor.health.t2.s1.description1': '健保轉入申請單',
  'ese.labor.health.t2.s1.description2': '健保IC卡申請表',

  'ese.labor.health.t2.s2.description1': '健保轉出申請書',

  'ese.labor.health.t2.s3.description1': '健保停復保申請書',

  'ese.labor.health.t2.s4.description1': '健保自墊醫療核退申請書',
  'ese.labor.health.t2.s4.description2': '委託書',

  'ese.labor.health.t3.s1.description1': '自提變更申請單',

  'ese.labor.health.t3.s2.description1': '勞工退休金申請書',

  'ese.labor.health.tx.sx.description1': '需備文件及流程',
  'ese.labor.health.tx.sx.description2': '申請條件及連結',

  'ese.my.application': '我的應用',

  'ese.all.application': '全部應用',
  'ese.all.application.subtitle': '聚合中央周邊業務系統，提供一站式便捷員工服務.',
  'ese.application.management': '應用管理',
  'ese.view.all': '查看全部',
  'ese.view.more': '查看更多',
  'ese.read.all': '查看全部',
  'ese.read.more': '查看更多',

  'ese.footer.taipei.human.resources.service.office': '台北人資服務總處',
  'ese.footer.service.line': '服務電話',

  'ese.th.serial.number': '序號',
  'ese.th.type': '類型',
  'ese.th.title': '標題',
  'ese.th.founder': '建立人',
  'ese.th.status': '狀態',
  'ese.th.setup.time': '建立時間',
  'ese.th.processor': '處理人',
  'ese.th.processing.time': '處理時間',
  'ese.th.operation': '操作',

  'ese.unread': '未讀消息',
  'ese.archived': '已讀消息',

  'ese.find.answers.to.some.frequently.asked.questions.here': '在這裡找到一些常見問題的答案.',
  'ese.question.and.answer': `常见问题解答`,

  'ese.none': '暫無',

  'ese.client.feedback': '問題反饋',
  'ese.client.reviews': '客戶評價',
  'ese.client.testimonials': '客戶評價',
  'ese.i.want.feedback': '我要反饋',
  'ese.business.group': 'Business group',

  'ese.employee.comment.request.form': '員工意見申請表',
  'ese.general': '基本資料',
  'ese.security': '修改密碼',

  ...labels,
  ...rules,
};

export default znJSON;
